// extracted by mini-css-extract-plugin
module.exports = {"link":"BoxLink_link__2BFU_","plusSign":"BoxLink_plusSign__AJDVI","label":"BoxLink_label__3Wj2m"};